import styled from 'styled-components'

export const PatientCreatingReservationRestrictionsModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0;
  gap: 20px;
`

export const SpinnerWrapper = styled.div`
  width: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SelectorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SelectRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  justify-content: flex-start;
  width: 100%;
  min-height: 52px;
`

export const DateSelectColumn = styled.div`
  flex: 0 0 96px;
  width: 96px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .RestrictionDateSelect {
    width: 100%;
    min-width: 0;

    > div {
      margin-top: 0;
      text-align: left;
      border: none;
      background: transparent;
      padding-left: 0;
      padding-right: 0;
      color: #2bb8c7;
      font-weight: 700;
      font-size: 40px;
      line-height: 24px;
    }
  }
`

export const ExceptionDateAsText = styled.span`
  font-weight: 700;
  color: #f03d3d;
  font-size: 15px;
  line-height: 1.2;
`

export const HourSelectionSlot = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  .RestrictionHourSelect {
    width: 150px;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 5px;

    > div {
      margin-top: 0;
      text-align: left;
    }
  }

  .Separator {
    color: #4d4d4d;
  }
`

export const NoAvailabilityState = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 52px;

  .NoAvailabilityText {
    color: #f03d3d;
    text-align: left;
    line-height: 16px;
    font-size: 12px;
    font-weight: 400;
  }
`

export const Footer = styled.div`
  max-width: 200px;
  margin: 0 auto;

  p {
    color: #898989;
  }
`
